

const initialState = {
    AllMyOrganzationUsers: [],
    organizationBySlug: null
  }
  
  const myorganizationReducers = (state = initialState, action) => {
    const { type, payload } = action
    
    switch (type) {
      case 'SET_ALL_MY_ORGANIZATION_USERS': {
        return {
          ...state,
          AllMyOrganzationUsers: payload,
        }
      }
      
      case 'SET_ORGANIZATION_BY_SLUG': {
        return {
          ...state,
          organizationBySlug: payload
        }
      }
      
      default:
        return state
    }
  }
  
  export default myorganizationReducers